import React, { createContext, useContext, useEffect, useState } from "react"
import { firestore } from "utils/firebase"

const ForeverXContext = createContext()

export const ForeverXProvider = (props) => {

  const [companyData, setCompanyData] = useState(null)

  useEffect(() => {
    const unsubscribeCompanyData = firestore
      .collection("foreverx")
      .doc("companyData")
      .onSnapshot(
        (snapshot) => {
          if (snapshot.exists) {
            let data = snapshot.data()
            setCompanyData((prev) => ({
              ...prev,
              ...data,
            }))
          }
        },
        (error) => {
          console.log("error fetching companyData", error);
        }
      )

    return () => {
      unsubscribeCompanyData()
    }
  }, [])

  return (
    <ForeverXContext.Provider
      value={{
        companyData
      }}
    >
      {props.children}
    </ForeverXContext.Provider>
  )
}

export const useForeverX = () => useContext(ForeverXContext)
